/**
 * Crops an image based on a selected region
 * @param {HTMLImageElement} image - The original image element
 * @param {Object} cropArea - The crop area coordinates and dimensions
 * @param {number} cropArea.x - The x coordinate of the top-left corner
 * @param {number} cropArea.y - The y coordinate of the top-left corner
 * @param {number} cropArea.width - The width of the crop area
 * @param {number} cropArea.height - The height of the crop area
 * @param {HTMLCanvasElement} canvas - The canvas element to use for cropping
 * @returns {Promise<string>} - Promise resolving to the cropped image data URL
 */
export const cropImage = (image, cropArea, canvas) => {
  return new Promise((resolve, reject) => {
    try {
      // Set canvas dimensions to the crop area dimensions
      canvas.width = cropArea.width;
      canvas.height = cropArea.height;
      
      // Draw the cropped section of the image
      const ctx = canvas.getContext('2d');
      ctx.drawImage(
        image,
        cropArea.x, cropArea.y, cropArea.width, cropArea.height, // Source coordinates and dimensions
        0, 0, cropArea.width, cropArea.height // Destination coordinates and dimensions
      );
      
      // Convert to data URL
      const dataUrl = canvas.toDataURL('image/png');
      resolve(dataUrl);
    } catch (error) {
      reject(error);
    }
  });
}; 